<div *ngIf="collection" class="flex flex-col">
    <div class="w-full h-full">
      <img
        loading="lazy"
        [src]="collection.featuredAsset | assetPreview:'full':'webp'"
        [alt]="collection.name"
        class="w-full h-full aspect-square object-cover pointer-events-none"
      />
    </div>

    <div class="flex flex-col items-center text-center">
      <p
        class="mt-4 mb-4 text-2xl font-medium text-[#2E3742] mix-blend-darken
               line-clamp-1"
        [title]="collection.name"
      >
        {{ collection.name }}
      </p>

      <button
        (click)="navigateToCollectionPage()"
        class="px-6 py-2 whitespace-nowrap text-base font-medium
               btn btn-primary hover:font-bold"
      >
        SHOP NOW
      </button>
    </div>
</div>
